import { Form, Modal, Select, SelectItem, Stack, TextInput } from '@carbon/react';
import { create, eager, enforce, test } from 'vest';

import { USER_ROLE, USER_ROLE_LABEL } from 'core/user/role';
import OverlayLoader from 'shared/components/OverlayLoader';
import useForm from 'utils/hooks/useForm';
import useUpdateEffect from 'utils/hooks/useUpdateEffect';

const mapDefaultValues = (user) =>
  user
    ? {
        name: user.name,
        email: user.email,
        role: user.role.toString()
      }
    : {
        name: '',
        email: '',
        role: ''
      };

const suite = create((data = {}) => {
  eager();

  test('name', 'Name is required', () => {
    enforce(data.name).isNotEmpty();
  });

  test('email', 'Email is required', () => {
    enforce(data.email).isNotEmpty().isEmail();
  });

  test('role', 'Role is required', () => {
    enforce(data.role).isNotEmpty();
  });
});

const UserModal = ({ open, user = null, onClose, onSubmit, isLoading }) => {
  const { register, handleSubmit, reset } = useForm({
    suite,
    defaultValues: mapDefaultValues(user)
  });

  useUpdateEffect(() => {
    if (open) {
      reset(mapDefaultValues(user));
    }
  }, [open, user]);

  const handleFormSubmit = (values) =>
    onSubmit({
      name: values.name,
      email: values.email,
      role: Number(values.role)
    });

  return (
    <Modal
      open={open}
      modalHeading={user ? 'Edit User details' : 'Add a User'}
      primaryButtonText={user ? 'Save' : 'Add'}
      secondaryButtonText="Reset"
      onRequestClose={onClose}
      onRequestSubmit={handleSubmit(handleFormSubmit)}
      onSecondarySubmit={() => reset()}
      preventCloseOnClickOutside
    >
      <Form onSubmit={handleSubmit(handleFormSubmit)}>
        <Stack gap={6}>
          <OverlayLoader isLoading={isLoading} />
          <TextInput id="name" labelText="Name*" placeholder="Input text" {...register('name')} />
          <TextInput id="email" labelText="Email*" placeholder="Input text" {...register('email')} />
          <Select id="role" labelText="Role*" {...register('role')}>
            <SelectItem disabled hidden value="" text="Choose a role" />
            {Object.values(USER_ROLE).map((r) => (
              <SelectItem key={r} value={r.toString()} text={USER_ROLE_LABEL[r]} />
            ))}
          </Select>
        </Stack>
      </Form>
    </Modal>
  );
};

export default UserModal;
